/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2019 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/
import {getIMSConfig} from './IMSConfig';
import React from 'react';
import ShellWait from '@exc/shell/src/ShellWait';

const BASE_CONFIG = {
  discoveryCache: false,
  endpoints: {
    apiGateway: 'https://exc-unifiedcontent.experience-qa.adobe.net',
    translation: 'https://mt-stage.adobe.io'
  }
};

const PROD_CONFIG = Object.assign({}, BASE_CONFIG, {
  endpoints: {
    apiGateway: 'https://exc-unifiedcontent.experience.adobe.net',
    translation: 'https://mt.adobe.io'
  }
});

/* eslint-disable sort-keys */
const ENV_TO_IMS = {
  test: 'stage',
  dev: 'stage',
  qa: 'stage',
  stage: 'stage',
  prod: 'prod'
};
/* eslint-enable sort-keys */

export const getConfiguration = (config = {}, imsEnv) => {
  config = Object.assign({cdn: '', environment: 'dev', region: undefined, scripts: {}, scriptsPath: '/assets'}, config);
  const {cdn, environment, scripts, scriptsPath, region} = config;

  let faviconDefault = document.querySelector('link[rel*="icon"]');
  const configEnvMap = {
    dev: BASE_CONFIG,
    prod: PROD_CONFIG,
    qa: BASE_CONFIG,
    stage: Object.assign({}, BASE_CONFIG, {
      endpoints: {
        apiGateway: 'https://exc-unifiedcontent.experience-stage.adobe.net'
      }
    }),
    test: BASE_CONFIG
  };

  if (!(environment in configEnvMap)) {
    throw new Error(`Invalid environment ${environment}`);
  }

  const defaultConfig = {
    defaultComponent: (
      <div className="full-screen">
        <ShellWait locale="en-US" />
      </div>
    ),
    environment,
    favicon: faviconDefault && faviconDefault.href,
    ims: getIMSConfig(imsEnv || ENV_TO_IMS[environment]),
    serviceEnvironment: getServiceEnvironment(environment, imsEnv)
  };
  let environmentConfig = imsEnv ? configEnvMap[imsEnv] : configEnvMap[environment];

  return Object.assign({cdn, region, scripts, scriptsPath}, defaultConfig, environmentConfig);
};

export const getServiceEnvironment = (env, imsEnv) => {
  if (env === 'prod' && imsEnv === 'stage') {
    return 'stage';
  }
  return imsEnv === 'prod' ? 'prod' : env;
};
